module.exports = __webpack_public_path__ + "static/img/网络诊室4大优势@2x.cd2edabe.png";